import { QuizTypeEnum } from './quiz-type-enum'

export interface QuizInterface {
  /**
   * 活动任务 ID
   */
  activityTaskId?: number
  /**
   * 试卷 ID
   */
  paperId?: number
  type: QuizTypeEnum
  /**
   * 测验时长(分钟)
   */
  minuteLimit?: number
  /**
   * 显示答案
   */
  showAnswer?: boolean
  /**
   * 显示姓名
   */
  showName?: boolean
  /**
   * 反作弊
   */
  againstCheat?: boolean
  /**
   * 出题数量
   */
  questionCount?: number
  /**
   * 通过得分率
   */
  passScoreRate?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Quiz implements QuizInterface {
  /**
   * 活动任务 ID
   */
  activityTaskId?: number
  /**
   * 试卷 ID
   */
  paperId?: number
  type: QuizTypeEnum
  /**
   * 测验时长(分钟)
   */
  minuteLimit?: number
  /**
   * 显示答案
   */
  showAnswer?: boolean
  /**
   * 显示姓名
   */
  showName?: boolean
  /**
   * 反作弊
   */
  againstCheat?: boolean
  /**
   * 出题数量
   */
  questionCount?: number
  /**
   * 通过得分率
   */
  passScoreRate?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: QuizInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityTaskId: _activityTaskId,
      paperId: _paperId,
      type: _type,
      minuteLimit: _minuteLimit,
      showAnswer: _showAnswer,
      showName: _showName,
      againstCheat: _againstCheat,
      questionCount: _questionCount,
      passScoreRate: _passScoreRate,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityTaskId = _activityTaskId
    this.paperId = _paperId
    this.type = _type
    this.minuteLimit = _minuteLimit
    this.showAnswer = _showAnswer
    this.showName = _showName
    this.againstCheat = _againstCheat
    this.questionCount = _questionCount
    this.passScoreRate = _passScoreRate
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
